export enum DestinationAddressConstants {
  NOT_IMPLEMENTED = 'destinationAddress/NOT_IMPLEMENTED',
  SET_TYPE = 'destinationAddress/SET_TYPE',
  SET_OTHER_TYPE = 'destinationAddress/SET_OTHER_TYPE',
  SET_HOSPITAL_IN_PATIENT_DESTINATION = 'destinationAddress/SET_HOSPITAL_IN_PATIENT_DESTINATION',
  SET_MODE_DESCRIPTORS = 'destinationAddress/SET_MODE_DESCRIPTORS',
  SET_MODE_DESCRIPTORS_PNNV = 'destinationAddress/SET_MODE_DESCRIPTORS_PNNV',
  SET_LOCATION = 'destinationAddress/SET_LOCATION',
  SET_ADDRESS_LINE1 = 'destinationAddress/SET_ADDRESS_LINE1',
  SET_ADDRESS_LINE2 = 'destinationAddress/SET_ADDRESS_LINE2',
  SET_APT_SUITE_ROOM = 'destinationAddress/SET_APT_SUITE_ROOM',
  SET_MILE_POST_MAJOR_ROADWAY = 'destinationAddress/SET_MILE_POST_MAJOR_ROADWAY',
  SET_CROSS_STREET_DIRECTIONS = 'destinationAddress/SET_CROSS_STREET_DIRECTIONS',
  SET_CITY = 'destinationAddress/SET_CITY',
  SET_STATE = 'destinationAddress/SET_STATE',
  SET_ZIP = 'destinationAddress/SET_ZIP',
  SET_COUNTRY = 'destinationAddress/SET_COUNTRY',
  SET_CENSUS_TRACT = 'destinationAddress/SET_CENSUS_TRACT',
  SET_COUNTY = 'destinationAddress/SET_COUNTY',
  SET_RECEIVING_RN = 'destinationAddress/SET_RECEIVING_RN',
  SET_RECEIVING_MD = 'destinationAddress/SET_RECEIVING_MD',
  SET_RECEIVING_USNG = 'destinationAddress/SET_RECEIVING_USNG',
  SET_RECEIVING_GPS_N = 'destinationAddress/SET_RECEIVING_GPS_N',
  SET_RECEIVING_GPS_E = 'destinationAddress/SET_RECEIVING_GPS_E',
  SET_COMMENT = 'destinationAddress/SET_COMMENT',
  SET_TRANSPORT_MODE = 'destinationAddress/SET_TRANSPORT_MODE',
  SET_TRANSPORT_MODE_PNNV = 'destinationAddress/SET_TRANSPORT_MODE_PNNV',
  SET_RESPONSE = 'destinationAddress/SET_RESPONSE',
  SAVE_DESTINATION_ADDRESS = 'destinationAddress/SAVE_DESTINATION_ADDRESS',
  SET_DISPOSITION_STATE = 'destinationAddress/SET_DISPOSITION_STATE',
  RESET_DISPOSITION_STATE = 'destinationAddress/RESET_DISPOSITION_STATE',
  SET_DESTINATION_BASIS = 'destinationAddress/SET_DESTINATION_BASIS',
  SET_DESTINATION_BASIS_PNNV = 'destinationAddress/SET_DESTINATION_BASIS_PNNV',
  SET_EMS_CHARTS_TYPE = 'destinationAddress/SET_EMS_CHARTS_TYPE',
  SET_DESTINATION_GRID = 'destinationAddress/SET_DESTINATION_GRID',
  SET_CAPABILITIES = 'destinationAddress/SET_CAPABILITIES',
  SET_CAPABILITIES_PNNV = 'destinationAddress/SET_CAPABILITIES_PNNV',
  RESET_DESTINATION_ADDRESS_STATE_ON_TYPE_CHANGE = 'destinationAddress/RESET_DESTINATION_ADDRESS_STATE_ON_TYPE_CHANGE',
  SET_DEFAULT_HOSPITAL_CODE = 'destinationAddress/SET_DEFAULT_HOSPITAL_CODE',
  SET_DEFAULT_EMS_CODE = 'destinationAddress/SET_DEFAULT_EMS_CODE',
  CALCULATE_RECEIVING_USNG = 'destinationAddress/CALCULATE_RECEIVING_USNG',
  SET_COMMON_ADDRESS = 'destinationAddress/SET_COMMON_ADDRESS',
  SET_STATE_IDS = 'destinationAddress/SET_STATE_IDS',
  SET_DESTINATION_ADDRESS_DEFAULTS = 'destinationAddress/SET_DESTINATION_ADDRESS_DEFAULTS',
}
